import { useEffect } from 'react'
import { classes } from 'typestyle'
import { useNavigate } from 'react-router-dom'

import { checkLogin, setPreviousRoute } from '../../../__aeki__/services/auth'

import useBoolean from '../../../__aeki__/hooks/use-boolean'
import useFetch from '../../../__aeki__/hooks/use-fetch'

import { Button } from '../../../__aeki__/components/button'
import { Modal } from '../../../__aeki__/components/modal'

import { primaryContrastMediumi } from '../../../__aeki__/styles/styleset/primary-contrast-medium/primaryContrastMediumi'

import { f18i } from '../../../__aeki__/styles/styleset/font-size/f18i'
import {
  ComponentBaselineType,
  ComponentSizeType,
} from '../../../__aeki__/components/__core/component.types'
import { f16i } from '../../../__aeki__/styles/styleset/font-size/f16i'

export const SaveButton = (props: {
  watched?: boolean
  id: string
  name: string
  refresh?: any
  float?: boolean
  size?: ComponentSizeType
  showLabel?: boolean
  className?: string
  isDelete?: boolean
  disableIcon?: boolean
  border?: boolean
  baseline?: ComponentBaselineType
  square?: boolean
}) => {
  const { square = true } = props
  const history = useNavigate()
  const [watched, $watched] = useBoolean(props.watched)
  const [savedList, $savedList] = useFetch({}, {})

  useEffect(() => {
    $watched.set(props.watched)
  }, [props.watched])

  return (
    <Button
      className={props.className}
      border={props.border}
      label={props.showLabel && (watched ? 'Saved' : 'Save')}
      baseline={props.isDelete ? 'surface' : watched ? 'primary' : props.baseline || 'surface'}
      size={props.size || 'sm'}
      float={props.float}
      icon={
        !props.disableIcon && (
          <span
            className={classes('material-icons-two-tone', f18i, watched && primaryContrastMediumi)}
          >
            {props.isDelete ? 'delete' : watched ? 'bookmark_added' : 'bookmark'}
          </span>
        )
      }
      ariaLabel={`Add ${props.name} to My Saved List`}
      onClick={(event: any) => {
        event.stopPropagation()
        event.preventDefault()

        if (props.isDelete) {
          Modal.push({
            type: 'Prompt',
            componentProps: {
              title: 'Alert',
              label: 'Are you sure to remove this from saved list?',
              confirmLabel: 'Delete',
              confirm: () => {
                Modal.pop()
                $watched.toggle()
                $savedList
                  .post({
                    url: `${process.env.REACT_APP_API_URL}/a/saved-list`,
                    body: { groupId: props.id },
                  })
                  .then(() => {
                    if (props.refresh) {
                      props.refresh()
                    }
                  })
              },
            },
          })
        } else {
          checkLogin(
            () => {
              $watched.toggle()
              $savedList
                .post({
                  url: `${process.env.REACT_APP_API_URL}/a/saved-list`,
                  body: { groupId: props.id },
                })
                .then(() => {
                  if (props.refresh) {
                    props.refresh()
                  }
                })
            },
            () => {
              Modal.pop()
              Modal.push({
                type: 'Prompt',
                componentProps: {
                  title: 'Alert',
                  label: 'You need to sign in to add this childcare to your saved list!',
                  confirmLabel: 'Sign in',
                  confirm: () => {
                    Modal.pop()
                    setPreviousRoute()
                    history('/a/signin')
                  },
                },
              })
            },
          )
        }
      }}
      square={square}
    />
  )
}
